export default "__VITE_ASSET__r2v5$Khq__"